import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { delay, finalize, Observable, Subject } from "rxjs";



@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

    constructor(private spinner: NgxSpinnerService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        const shouldNotShowSpinner = req.headers.get('not-show-spinner') === 'true';
        if(shouldNotShowSpinner == false){
            this.spinner.show();

        }

        // Clone the request to remove the custom header before sending it to the server
        const clonedRequest = req.clone({ headers: req.headers.delete('show-spinner') });

        return next.handle(clonedRequest).pipe(
            // Add a delay here (e.g., 2 seconds)
            // Hide the spinner
            finalize(() => {
                this.spinner.hide()
            })
        );
    }



}